import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

export default function AdminLoginPage() {
  const navigate = useNavigate()
  const { signIn, isAuthenticated } = useAuth()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  // Redirect if already authenticated
  if (isAuthenticated) {
    navigate('/admin')
    return null
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setIsLoading(true)

    try {
      await signIn(email, password)
      navigate('/admin')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <h1 className="text-foreground font-display text-center text-2xl font-bold">Admin Login</h1>
        <p className="text-foreground-muted mt-2 text-center">Sign in to manage the photography competition.</p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-6">
          <div>
            <label htmlFor="email" className="text-foreground-muted block text-sm font-medium">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border-border bg-surface text-foreground placeholder:text-foreground-subtle focus:border-accent focus:ring-accent mt-1 block w-full rounded-lg border px-4 py-3 focus:ring-1 focus:outline-none"
              placeholder="teacher@sierracanyonschool.org"
              required
            />
          </div>

          <div>
            <label htmlFor="password" className="text-foreground-muted block text-sm font-medium">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border-border bg-surface text-foreground placeholder:text-foreground-subtle focus:border-accent focus:ring-accent mt-1 block w-full rounded-lg border px-4 py-3 focus:ring-1 focus:outline-none"
              placeholder="••••••••"
              required
            />
          </div>

          {error && <div className="bg-error/10 border-error/20 text-error rounded-lg border p-4 text-sm">{error}</div>}

          <button
            type="submit"
            disabled={isLoading}
            className="bg-accent text-accent-foreground hover:bg-accent-muted w-full rounded-lg px-6 py-3 font-semibold shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  )
}
